<template>
	<WindowForAlert :title="getLanguageStr('cmd79','导入')"
									:size="'m'"
									ref="importViewTick"
									class=''
									@Cancel='cancel'
									:btnClose='true'
									:btnCancel='closeshow'
									id="importViewTick">
		<Loading ref="loading"></Loading>
		<div v-show='status===1'
				 class='w100pct-max posR pb3x'>
			<table class="">
				<tbody>
					<tr>
						<td class="dpIB_E vaM_E">
							<InputText class="w60pct"
												 name="filename"
												 v-model="fileName"
												 verifyMethod=''></InputText>
							<label class="w7x sizeM sizeM-lh ml05x pl05x pr05x bdSub boxR hover-bg-highLight taC curP textCut tra-fast"
							onclick="statistic('A29','A2904')"
										 :title="getLanguageStr('word3','选择文件')">
								<input type="file"
											 name="file"
											 @change="onChangefile"
											 ref="file" />
								<span>{{getLanguageStr('word3','选择文件')}}</span>
							</label>
						</td>
					</tr>
				</tbody>
			</table>

			<div class="mt1x cSub taL fs12x pl1x">
				<p>{{getLanguageStr("phrase939","导入布局文件将快速匹配电站内的已有设备的布局信息")}}</p>
				<p>{{getLanguageStr("phrase940","步骤1:请确保电站内已添加完所有的组件SN号")}}</p>
				<p>{{$t('fill3rd179', [2,'步骤 x'])}}:<a target='_blank'
						 @click='functionExport' onclick="statistic('A29','A2905')"
						 class='cMain'>{{getLanguageStr('cmd255','点击这里')}}</a>{{getLanguageStr("phrase949","导出该电站的所有组件信息")}}</p>
				<p>{{getLanguageStr("phrase941","步骤3:在导出的xls文件中输入布局信息。")}}<a target='_blank'
						 class='cMain'>{{getLanguageStr('phrase942','布局信息该怎么填？')}}<Help :code="'LayoutDownload'"  onmouseenter="statistic('A29','A2906')"
									:btnClose="false"
									class="vaM ml1x"></Help></a></p>
				<p>{{getLanguageStr("phrase943","步骤4:导入已完善的布局信息xls文件。")}}</p>
				<p>
					{{getLanguageStr('phrase944','你也可以直接')}}
					<a target='_blank'
					onclick="statistic('A29','A2907')"
						 :href='stage.loc.baseRouter+"static/file/"+ (importFile[stage.languageId]?importFile[stage.languageId]:importFile["en"])'
						 class='cMain'>{{getLanguageStr('word1931','点击下载导入文件模版')}}</a>
				</p>
			</div>

		</div>
		<div v-show='status===2'>
			<p style="font-size:1.4rem">{{getLanguageStr('word1932','导入成功')}}</p>
			<p>{{this.msg}}</p>
		</div>
		<div v-show='status===3'>
			<p style="font-size:1.4rem">{{getLanguageStr('word1933','导入失败')}}</p>
			<p>{{this.msg}}</p>
		</div>
		<button v-show='status===1'
						slot="btmBtn"
						class="functionBtn"
						v-debounce:click="save"
						 onclick="statistic('A29','A2909')"
						:title="status===1?$t('cmd12',['确定']):$t('cmd15',['我知道了'])"
						type="button">{{status===1?$t('cmd12',['确定']):$t('cmd15',['我知道了'])}}</button>
		<button v-show='status!==1'
						slot="btmBtn"
						class="functionBtn"
						v-debounce:click="knows"
						:title="status===1?$t('cmd12',['确定']):$t('cmd15',['我知道了'])"
						type="button">{{status===1?$t('cmd12',['确定']):$t('cmd15',['我知道了'])}}</button>

	</WindowForAlert>
</template>
<script>
import WindowForAlert from '@/components/common/ui/WindowForAlert.vue'
import InputText from '@/components/common/ui/InputText'
import Help from '@/components/common/Help.vue'
import Select from '@/components/common/ui/Select.vue'
import * as lib from '@/util/lib'
import { getLanguageStr } from '@/util/language'
import Loading from '@/components/common/ui/Loading'
import { importLayout } from '@/api/maintain/layout/index'
import { exportLayout } from '@/api/maintain/layout/index'
export default {
	name: 'importView',
	components: { WindowForAlert, InputText, Select, Loading, Help },
	data () {
		return {
			stage,
			basicInfo: {},
			closeshow: true,
			systemId: null,
			maxSize: 100000000000000,
			fileName: '',
			fileTypeList: ['xlsx', 'xls', 'csv'],
			excelFile: '',
			showB: true,
			status: 1,
			msg: '',
			instance: '',
			exportData: {},
			importFile: {
				zh: '系统布局信息导入表格模版.xlsx',
				en: 'File Template.xlsx',
				pt: 'Modelo de arquivo.xlsx',
				es: 'Plantilla de archivo.xlsx'
			}
		}
	},
	created () {
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		cancel () {
			statistic('A29', 'A2908')
		},
		knows () {
			if (this.status === 2) {
				// TODO colsePanel
				this.$refs.importViewTick.hide()
			} else {
				this.excelFile = ''
				this.$refs.file.value = ''
				this.fileName = ''
				this.status = 1
			}
		},
		functionExport () {
			this.exportData.systemId = this.systemId
			exportLayout(this.basicInfo.id, this.exportData).then(res => {
				let blob = new Blob([res], { type: 'application/ms-excel' })
				let downloadElement = document.createElement('a')
				let href = window.URL.createObjectURL(blob) // 创建下载的链接
				downloadElement.href = href
				// console.log(this.basicInfo)
				let title = `电站${this.basicInfo.name}系统布局信息`
				title = i18n.t('fill3rd177', [this.basicInfo.name, '电站{0}系统布局信息'])
				downloadElement.download = `${title}.xlsx` // 下载后文件名 fill3rd177
				document.body.appendChild(downloadElement)
				downloadElement.click() // 点击下载
				document.body.removeChild(downloadElement) // 下载完成移除元素
				window.URL.revokeObjectURL(href) // 释放掉blob对象
			}, error => {
				// console.log(error)
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		onChangefile (event) {
			if (event.target.files.length == 0) return
			let f = event.target.files[0]
			if (f.size > this.maxSize) {
				this.$notify(i18n.t('fill3rd13', [this.maxSize / (1024 * 1024), '文件不超过{0}MB']))
			} else {
				let fn = f.name.toLowerCase(), ext, fnI
				fnI = fn.lastIndexOf('.')
				ext = fn.substring(fnI + 1)

				if (this.fileTypeList.includes(ext)) {
					this.excelFile = f
					this.fileName = f.name
				} else {
					this.$notify(i18n.t('fill3rd186', ['xlsx、xls、csv', '请上传xlsx、xls、csv文件']))
				}
			}
		},
		show (basicInfo, systemId, exportData, instance) {
			this.closeshow = true
			this.instance = instance
			this.basicInfo = basicInfo
			this.exportData = exportData
			this.systemId = systemId
			this.$refs.loading.hide()
			this.$refs.importViewTick.show()
		},
		close () {
			this.$refs.importViewTick.hide()
			setTimeout(() => {
				this.instance.destroyUi()
			}, 500)
		},
		save () {
			this.showB = false
			if (this.excelFile == '') {
				this.$notify(getLanguageStr('word1685', '请上传EXCEL文件'))
				this.showB = true
				return false
			}
			this.$refs.loading.show()
			let data = {
				file: this.excelFile,
				systemId: this.systemId,
				id: this.basicInfo.id
			}
			let formData = new FormData()
			formData.append('file', data.file)
			formData.append('systemId', data.systemId)
			formData.append('id', data.id)
			importLayout(data.id, formData).then(responseData => {
				this.closeshow = false
				this.status = 2
				this.msg = i18n.t('plant445', [responseData.layoutItem.length, 'X个组件SN已全部导入'])
				this.$refs.loading.hide()
				this.showB = true
				this.$emit('Update',responseData);
				// layoutItem(data.id, data).then(data => {
				//   this.$emit('Getcomdata', data)
				// })
				// this.hide()
			}, err => {
				this.closeshow = false
				this.msg = err
				this.status = 3
				this.showB = true
				this.$refs.loading.hide()
			}).then(() => {

			})
		},
		getAllCom () {

		}
	},
	computed: {}
}
</script>
<style  lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/layout/ImportView.vue